export default async function navigationGuardPermissions(to, store) {
  if (!to.name.includes('.')) {
    return true;
  }
  const rules = {
    m: 'maj',
    c: 'lecture',
    l: 'lecture',
  };
  // Je vais taper dans mon objet rules pour récupérer la valeur correspondante
  const rule = rules[to.name.split('.')[0]];
  const module = to.name.split('.')[1];
  let element = to.name.split('.')[2];
  element = element.split('-')[0];
  const permissions = {
    module,
    element,
    rule,
  };
  const isAllowed = await store.getters['permissions/checkPermissions'](permissions);
  if (isAllowed === true) return true;
  store.dispatch('permissions/showPopup');
  return false;
}
